/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  HCPSpecificMessage,
  HCPSpecificMessageFromJSON,
  HCPSpecificMessageFromJSONTyped,
  HCPSpecificMessageToJSON,
} from "./";

/**
 *
 * @export
 * @interface HCPSpecificMessageIEnumerableControllerResponse
 */
export interface HCPSpecificMessageIEnumerableControllerResponse {
  /**
   *
   * @type {Array<HCPSpecificMessage>}
   * @memberof HCPSpecificMessageIEnumerableControllerResponse
   */
  data?: Array<HCPSpecificMessage> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof HCPSpecificMessageIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function HCPSpecificMessageIEnumerableControllerResponseFromJSON(
  json: any,
): HCPSpecificMessageIEnumerableControllerResponse {
  return HCPSpecificMessageIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function HCPSpecificMessageIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HCPSpecificMessageIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(HCPSpecificMessageFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function HCPSpecificMessageIEnumerableControllerResponseToJSON(
  value?: HCPSpecificMessageIEnumerableControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(HCPSpecificMessageToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
